<template lang="pug">
content-page
	div(slot="nav")
		v-btn.mb-6(color="primary" outlined block nuxt exact :to="localePath({name:'gear-category', category: product.category.slug})") &laquo; terug naar {{product.category.slug}}
		v-card.mb-6(outlined color="info" v-if="product.category.clusters.length")
			.pa-2
				nuxt-link.black--text.h4(:to="localePath({name:'gear-category', params: {category: product.category.slug}})") {{product.category.name}}
				ul.list-unstyled
					li(v-for="cluster in product.category.clusters" :key="cluster.id" :title="cluster.name")
						nuxt-link(:to="localePath({name:'gear-category-cluster', params: {category: product.category.slug, cluster: cluster.slug}})" active-class="active")
							ws-icon(color="accent" small) angle-right
							small.accent--text {{cluster.name}}
	.hidden-sm-and-down(slot="sidebar" style="max-width: 280px;")
		ad(location="sidebar").mb-6
		offers.mb-6
	.d-flex.justify-space-between
		div
			h1.mb-0 {{product.name}}
			.d-block.accent--text.title.text-no-wrap.font-weight-bold v.a. {{ $n(product.price, 'currency', $i18n.locale) }}
			p.grey--text.caption
				v-icon.mr-2(small color="grey") info
				| {{$t('page.gear:product:label_last_update')}} {{$dayjs(product.updated_at).format('D MMMM YYYY')}}
		v-sheet.gear--product-rating__large.accent.white--text(tile v-if="product.category.id !== '32e32d17-179f-59a5-9b45-b8dea2a1b6ba'") {{product.rating}}
	.flow-left
		.mb-3(v-if="productImages.length || product.videos")
			template(v-if="activeMedia === 'image'")
				v-img.mb-2(v-if="activeImage" :src="`${activeImage.url}?width=640`" :alt="activeImage.alt")
			vue-plyr.mb-2(v-else-if="product.videos && product.videos.length && product.videos[0].videoSource === 'youtube' || product.videos[0].videoSource === 'vimeo'" small ref="plyr" :options="{'controls':['play', 'volume', 'play-large', 'airplay', 'fullscreen', 'pip', 'mute'], 'disableContextMenu': false}")
				div(v-if="product.videos && product.videos.length" :data-plyr-provider="product.videos[0].videoSource" :data-plyr-embed-id="product.videos[0].videoId")
			video-hls(v-else-if="product.videos && product.videos.length && product.videos[0].videoSource === 'video'" :videoUrl="product.videos[0].videoId")
			v-row.grey--text.mb-6(dense)
				v-col(cols="2" v-for="(image, index) in productImages" :key="`image-${index}`")
					a(@click.prevent="activeMedia='image'; activeImageIndex=index")
						v-img(:src="`${image.url}?width=640`" :alt="image.alt")
				v-col(cols="2" v-if="product.videos && product.videos.length && product.videos[0].thumb")
					a(@click.prevent="activeMedia='video'")
						v-img.play-btn(:src="product.videos[0].thumb")
			v-divider
		.mb-3(v-if="!product.isAvailable")
			.mb-3
				ws-icon.vertical-align-sub(small color="grey") exclamation-circle
				| {{$t('page.gear:product:label_no_longer_sold')}}
			v-divider
		.mb-6
			ul.grey--text.list-unstyled.mb-3
				li.d-inline-block.mr-2(v-if="product.audience.markdown.length")
					a(href="#doelgroep") {{$t('page.gear:product:anchor_label_audience')}}
				li.d-inline-block.mr-2(v-if="groupedFeatureValues.length")
					a(href="#specificaties") {{$t('page.gear:product:anchor_label_specs')}}
				li.d-inline-block.mr-2
					a(href="#vergelijk") {{$t('page.gear:product:anchor_label_compare')}}
			v-divider
		div(v-if="product.aspects.length")
			h2.mb-3 {{$t('page.gear:product:label_aspects')}}
			.d-flex.justify-space-between.mb-6
				ul.list-unstyled
					li.d-flex(v-for="aspect in positiveAspects" :key="aspect.id")
						ws-icon.gear-icon--align-start.mr-3(small color="success") plus
						.d-inline-block {{aspect.name}}
				ul.list-unstyled
					li.d-flex(v-for="aspect in negativeAspects" :key="aspect.id")
						ws-icon.gear-icon--align-start.mr-3(small color="error") minus
						.d-inline-block {{aspect.name}}
		.mb-6(v-if="product.findings.markdown.length")
			h2 {{$t('page.gear:product:label_findings')}}
			ws-content(:value="product.findings" level="3")
		.mb-6#doelgroep(v-if="product.audience.markdown.length")
			h2 {{$t('page.gear:product:label_audience')}}
			ws-content.mb-3(:value="product.audience" level="3")
			div(v-if="product.clusters.length")
				h3 {{$t('page.gear:product:label_scores')}}
				v-list
					v-list-item.pl-0
						v-list-item-avatar(tile)
							v-sheet.gear--product-rating.accent.white--text(tile) {{product.rating}}
						v-list-item-content
							v-list-item-title.py-2 {{$t('page.gear:product:table_cell_general_rating')}}
					template(v-for="{cluster, rating} in product.clusters" v-if="cluster")
						v-divider
						v-list-item.pl-0(:to="localePath({name: 'gear-category-cluster', params: {category: product.category.slug, cluster: cluster.slug}})")
							v-list-item-avatar(tile)
								v-sheet.gear--product-rating.accent.white--text(tile) {{rating}}
							v-list-item-content
								v-list-item-title.body.py-2.primary--text {{cluster.name}}

		.mb-6(v-if="product.deeplinks.length")
			h2(v-if="product.deeplinks.length === 1") {{$t('page.gear:product:label_available_at_store')}}
			h2(v-else) {{$t('page.gear:product:label_available_at_{length}_stores', product.deeplinks.length)}}
			v-list
				v-divider
				template(v-for="deeplink in product.deeplinks")
					v-list-item.px-0(:href="`/redir?u=${encodeURIComponent(deeplink.partnerfeed.url)}&p=${deeplink.partner.slug}&i=${deeplink.id}&t=gear&h=${$redirHash(deeplink.partnerfeed.url)}`" target="_blank" rel="nofollow" v-if="deeplink.partnerfeed && deeplink.partnerfeed.url")
						v-list-item-icon(v-if="deeplink.partner")
							img.gear-logo--small(:src="`${deeplink.partner.mainImage}?width=640`" :alt="deeplink.partner.name" height="21px")
						v-list-item-content
							v-list-item-title.accent--text.text-right(v-if="deeplink.partnerfeed.price") {{ $n(deeplink.partnerfeed.price, 'currency', $i18n.locale) }}
						v-list-item-action
							v-btn(:href="`/redir?u=${encodeURIComponent(deeplink.partnerfeed.url)}&p=${deeplink.partner.slug}&i=${deeplink.id}&t=gear&h=${$redirHash(deeplink.partnerfeed.url)}`" small color="warning" depressed) {{$t('page.gear:product:button_check')}}
					v-list-item.px-0(:href="`/redir?u=${encodeURIComponent(deeplink.url)}&p=${deeplink.partner.slug}&i=${deeplink.id}&t=gear&h=${$redirHash(deeplink.url)}`" target="_blank" rel="nofollow" v-else-if="deeplink.url")
						v-list-item-icon(v-if="deeplink.partner")
							img.gear-logo--small(:src="`${deeplink.partner.mainImage}?width=640`" :alt="deeplink.partner.name" height="21px")
						v-list-item-content
							v-list-item-title.accent--text.text-right(v-if="deeplink.price") {{ $n(deeplink.price, 'currency', $i18n.locale) }}
						v-list-item-action
							v-btn(:href="`/redir?u=${encodeURIComponent(deeplink.url)}&p=${deeplink.partner.slug}&i=${deeplink.id}&t=gear&h=${$redirHash(deeplink.url)}`" small color="warning" depressed) {{$t('page.gear:product:button_check')}}
					v-divider

		.mb-6(v-if="product.conditions.markdown.length")
			h2 {{$t('page.gear:product:label_conditions')}}
			ws-content(:value="product.conditions" level="3")

		.mb-6.gear--features(v-if="product.featureValues")
			template(v-if="particularFeatures.length")
				h2.mb-3 {{$t('page.gear:product:heading_particularities')}}
				template(v-for="particularFeature in particularFeatures")
					nuxt-link.black--text(v-if="particularFeature.option.content.markdown !== ''" exact :to="localePath({name:'gear-features-feature', params: {slug: particularFeature.option.feature.slug}})")
						h3.d-inline {{particularFeature.option.feature.name}}
						ws-icon.vertical-align-baseline(small color="primary") information-circle
					h3(v-else) {{particularFeature.option.feature.name}}
					ws-content.mb-3(:value="particularFeature.content" level="4")
			template(v-if="groupedFeatureValues.length")
				h2#specificaties {{$t('page.gear:product:label_specs')}}
				v-list
					template(v-for="(featureValue, index) in groupedFeatureValues")
						v-divider
						v-list-item.lighten-4(:class="{ grey: !(index % 2) }")
							v-list-item-content
								v-list-item-title.py-0.break-spaces.font-weight-bold
									nuxt-link.black--text(v-if="featureValue.markdown !== ''" exact :to="localePath({name:'gear-features-feature', params: {slug: featureValue.slug}})")
										span {{featureValue.name}}
										ws-icon.vertical-align-baseline(small color="primary") information-circle
									span(v-else) {{featureValue.name}}
							v-list-item-content
								v-list-item-title.py-0.break-spaces {{featureValue.option}}

		h2.mt-6 Vergelijkbare {{product.category.slug}}
		v-simple-table#vergelijk.gear--similar
			tbody
				tr(v-for="similarProduct in similarProducts" :key="similarProduct.id")
					td(v-if="category.slug !== 'skis'").py-2
						v-sheet.gear--product-rating.grey.white--text(v-if="similarProduct.rating" tile) {{similarProduct.rating}}
					td.similar-product--link.py-2
						nuxt-link(:to="localePath({name: 'gear-category-product-product', params: { category: product.category.slug, product: similarProduct.slug }})")
							h3 {{similarProduct.name}}
					td.py-2
						v-img.gear-product--flow-right(:src="similarProduct.mainImage" width="48" height="48")
					td.py-2.text-right
						h3.accent--text {{ $n(similarProduct.price, 'currency', $i18n.locale) }}
		.text-center.my-3
			v-btn(color="primary" outlined nuxt exact :to="localePath({name:'gear-category', category: product.category.slug})") bekijk alle {{product.category.slug}}

</template>

<style lang="sass">
.gear--product-rating, .gear--product-rating__large
	float: right
	text-align: center
	display: inline-block

.gear--product-rating
	width: 36px
	height: 36px
	line-height: 36px
	font-size: 15px
	&__large
		width: 40px
		height: 40px
		line-height: 40px
		font-size: 18px
		font-weight: bold

.vertical-align-sub
	vertical-align: sub !important

.vertical-align-baseline
	vertical-align: baseline !important

.gear--similar
	tr
		td
			&:first-child:not(.similar-product--link)
				width: 1px
				padding-left: 0
			&.similar-product--link
				width: auto
			&:last-child
				width: 1px
				padding-right: 0

.gear--similar, .gear--specs
	tr
		h3
			margin-bottom: 0

.gear-logo--small
	vertical-align: middle

.gear-icon--align-start
	align-self: start
	margin-top: 5px

.gear-product--flow-right
	float: right

.gear--features
	a:hover span
		text-decoration: underline

.break-spaces
	white-space: break-spaces !important
</style>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import itemsjs from 'itemsjs';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const gearProducts = gql`
	query gearProducts($slug: String, $category: String) {
		product: gearProduct(slug: $slug) {
			id
			category {
				id
				slug
				name
				clusters {
					id
					name
					slug
				}
				features {
					feature {
						id
						name
						slug
					}
					sort
				}
			}
			name
			slug
			rating
			price
			collection
			mainImage
			images {
				alt
				url
				caption
			}
			deeplinks {
				id
				url
				price
				partnerfeed {
					price
					url
				}
				partner {
					id
					name
					slug
					mainImage
				}
			}
			clusters {
				rating
				cluster {
					id
					name
					slug
					mainImage
					content {
						...ContentDataFragment
					}
					category {
						id
						slug
						name
					}
				}
			}
			findings {
				...ContentDataFragment
				introduction
			}
			conditions {
				...ContentDataFragment
			}
			audience {
				...ContentDataFragment
			}
			aspects {
				id
				name
				isPositive
			}
			featureValues {
				content {
					...ContentDataFragment
				}
				option {
					slug
					name
					content {
						...ContentDataFragment
					}
					feature {
						slug
						name
					}
				}
			}
			videos {
				videoId
				videoSource
				isDefault
				description
				thumb
			}
			isActive
			isAvailable
			updated_at
			...MetaFragment
		}
		category: gearCategory(slug: $category) {
			id
			products {
				id
				name
				slug
				mainImage
				rating
				price
				featureValues {
					content {
						...ContentDataFragment
					}
					option {
						slug
						name
						feature {
							slug
						}
					}
				}
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/materiaal/:category/product/:product',
			'nl-BE': '/materiaal/:category/product/:product'
		}
	},
	layout: 'default',
	asyncData({ params, app }) {
		return app.$graphClient
			.query({
				query: gearProducts,
				variables: {
					slug: params.product,
					category: params.category
				},
				errorPolicy: 'all',
				fetchPolicy: 'network-only'
			})
			.then(({ data, errors }) => {
				if (!data.product || data.product.category.slug !== params.category) {
					return app.httpError(
						404,
						null,
						'gear-category-product-product-01',
						errors
					);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.product.meta);
				app.ads({});
				app.breadcrumbs({
					[app.i18n.t('page.gear:breadcrumb')]: {
						name: 'gear'
					},
					[data.product.category.name]: {
						name: 'gear-category',
						params: { category: params.category }
					},
					[data.product.name]: {
						name: 'gear-category-product-product'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(
					500,
					null,
					'gear-category-product-product-02',
					error
				);
			});
	},
	data: () => {
		return {
			activeImageIndex: 0,
			activeMedia: 'image'
		};
	},
	head() {
		return this.$lodash.merge(this.$structuredData(), {
			script: [
				{
					innerHTML: JSON.stringify({
						'@context': 'https://schema.org/',
						'@type': 'Product',
						// brand: {
						// 	'@type': 'Brand',
						// 	name: 'this.product.brand.name'
						// },
						description: this.product.findings.introduction,
						image: this.product.mainImage,
						name: this.product.name,
						review: {
							'@type': 'Review',
							reviewRating: {
								'@type': 'Rating',
								ratingValue: this.product.rating,
								bestRating: 10
							},
							author: {
								'@type': 'Organization',
								name: 'wintersport.nl'
							}
						}
					}),
					type: 'application/ld+json',
					hid: 'product-schema'
				}
			]
		});
	},
	computed: {
		particularFeatures() {
			return this.product.featureValues.filter(f => f.content.markdown !== '');
		},
		groupedFeatureValues() {
			const sortedFeatures = new Map();
			this.product.category.features.forEach(categoryFeature => {
				sortedFeatures.set(categoryFeature.feature.slug, categoryFeature.sort);
			});

			const newFeatureValues = this.product.featureValues.map(featureValue => {
				return {
					slug: featureValue.option.feature.slug,
					name: featureValue.option.feature.name,
					option: featureValue.option.name,
					markdown: featureValue.option.content.markdown,
					sort: sortedFeatures.get(featureValue.option.feature.slug)
				};
			});

			const sorted = newFeatureValues.sort((a, b) => {
				return a.sort - b.sort;
			});

			const output = [];

			sorted.forEach(featureValue => {
				const existing = output.filter(
					outputItem => outputItem.name === featureValue.name
				);

				if (existing.length) {
					const existingIndex = output.indexOf(existing[0]);
					output[existingIndex].option = output[existingIndex].option.concat(
						` / ${featureValue.option}`
					);
					output[existingIndex].markdown = output[existingIndex].markdown
						? output[existingIndex].markdown
						: featureValue.markdown;
				} else {
					output.push(featureValue);
				}
			});

			return output;
		},
		productImages() {
			return this.product.mainImage
				? [
						{ url: this.product.mainImage, alt: '', caption: '' },
						...this.product.images
				  ]
				: this.product.images;
		},
		activeImage() {
			return this.productImages[this.activeImageIndex];
		},
		positiveAspects() {
			return this.product.aspects.filter(a => a.isPositive);
		},
		negativeAspects() {
			return this.product.aspects.filter(a => !a.isPositive);
		},
		similarProducts() {
			const searchableFields = ['rating', 'price'];
			const aggregations = {};

			this.product.category.features.forEach(categoryFeature => {
				searchableFields.push(categoryFeature.feature.slug);
				aggregations[categoryFeature.slug] = {
					title: categoryFeature.name,
					size: 25,
					conjunction: false
				};
			});

			const filterConfiguration = {
				searchableFields,
				aggregations
			};

			const result = itemsjs(this.flatProducts, filterConfiguration).similar(
				this.product.id,
				{
					field: this.product.category.features.map(
						categoryFeature => categoryFeature.feature.slug
					),
					per_page: 5
				}
			);
			return result.data.items;
		},
		flatProducts() {
			if (!this.category.products.length) return [];

			return this.category.products.map(product => {
				const newProduct = { ...product, featureTexts: {} };
				product.featureValues
					.filter(featureValue => featureValue)
					.forEach(featureValue => {
						newProduct[featureValue.option.feature.slug] =
							newProduct[featureValue.option.feature.slug] || [];
						newProduct[featureValue.option.feature.slug].push(
							featureValue.option.name
						);

						if (featureValue.content.markdown) {
							newProduct.featureTexts[featureValue.option.feature.slug] =
								newProduct.featureTexts[featureValue.option.feature.slug] || [];
							newProduct.featureTexts[featureValue.option.feature.slug].push(
								featureValue.content.markdown
							);
						}
					});

				return newProduct;
			});
		}
	}
};
</script>
